<!-- src/components/LayerPage6.vue -->
<template>
  <div class="whole-container">
    <div class="header">
      <h1> Bulk Transcriptomics of Stromal Cell (secretory) </h1>
      <div class="function_description">
          <p> Bulk RNA sequencing was performed on endometrial stromal cells from symptomatic women with pathologically confirmed diffuse adenomyosis and female age-matched health control in the middle-secretory phase using the Illumina NovaSeq 6000 platform. Data was from the study of Gan et al. (DOI: 10.1080/21655979.2022.2077614). </p>
        </div>
    </div>
    <GeneChoose uniqueId="function_6" function_name="function_6" description="Enter a gene to explore its expression in the endometrial stromal cells of secretory phase adenomyosis"></GeneChoose>
    <!-- Your content for Page 1 goes here -->
  </div>
</template>

<script>
import GeneChoose from '@/components/GeneChoose.vue';
export default {
  components: {
    GeneChoose,
},
  name: 'PageSix'
}
</script>